import apiClient from "./client";

export interface ActualsThroughPayload {
  actual_through: string; // YYYY-MM-DD
}

export interface ActualsThroughResponse {
  actual_date?: string | null; // YYYY-MM-DD
  created_at?: string;
}

export async function postActualsThrough(
  actual_through: string,
): Promise<void> {
  const payload: ActualsThroughPayload = { actual_through };
  await apiClient.post("/api/v1/rolems/actuals_through", payload);
}

export async function fetchActualsThrough(): Promise<string | null> {
  const res = await apiClient.get<ActualsThroughResponse>(
    "/api/v1/rolems/get_actuals_through",
  );
  const actual = res.data?.actual_date;
  return actual ? String(actual) : null;
}

